
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Koregaonparktomumbaicab() {



    const cardData =
    {
        keyword: 'Koregaon Park to Mumbai Cab',
        heading: 'Vedant Travels: Koregaon Park to Mumbai Cab ',
        headingDescription: 'Vedant Travels offers dependable and budget-friendly Koregaon Park to Mumbai Cab services, making your journey smooth, safe, and convenient. With transparent fares and no hidden charges, we provide multiple cab options such as Sedan, SUV, and Innova Crysta to match your comfort and budget requirements. Whether you need a one-way drop, airport transfer, or round-trip travel, our experienced drivers ensure punctuality, safety, and a pleasant ride. Easy online booking, 24x7 service availability, and well-maintained vehicles make Vedant Travels the trusted choice for reliable Koregaon Park to Mumbai cab services.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


"services": [
    {
        "name": "Koregaon Park to Mumbai Airport Cab",
        "description": "Book a comfortable and reliable ride from Koregaon Park to Mumbai Airport with Vedant Travels. Our professional drivers ensure you reach the airport on time and in comfort."
    },
    {
        "name": "Koregaon Park to Mumbai International Airport Cab",
        "description": "Looking for a taxi from Koregaon Park to Mumbai International Airport? Vedant Travels offers efficient and affordable services, making sure you get to your flight in a timely manner."
    },
    {
        "name": "Koregaon Park to Mumbai Airport Drop Taxi",
        "description": "Traveling to Mumbai Airport from Koregaon Park? Our drop taxi service is available at competitive prices, providing you with a smooth and hassle-free ride."
    },
    {
        "name": "Koregaon Park to Mumbai Airport One Way Taxi",
        "description": "For a one-way trip from Koregaon Park to Mumbai Airport, choose Vedant Travels. We offer affordable and reliable one-way taxi services for your convenience."
    },
    {
        "name": "Koregaon Park to Mumbai Round Trip",
        "description": "Looking for a round trip from Koregaon Park to Mumbai? Vedant Travels offers round trip services that ensure comfort, flexibility, and punctuality for your return journey as well."
    },
    {
        "name": "Cab Service in Koregaon Park",
        "description": "Vedant Travels offers top-rated cab services in Koregaon Park. Whether you're heading to Mumbai or need a local ride, we provide reliable and comfortable transportation to suit your needs."
    },
    {
        "name": "Koregaon Park to Santacruz Cab Fare",
        "description": "Get an affordable and convenient taxi service from Koregaon Park to Santacruz with Vedant Travels. Our transparent pricing ensures that your trip is both budget-friendly and comfortable."
    },
    {
        "name": "Koregaon Park to Mumbai Central Cab",
        "description": "Traveling from Koregaon Park to Mumbai Central? Book your ride with Vedant Travels for a smooth and hassle-free journey. Our fleet includes a range of comfortable vehicles to choose from."
    },
    {
        "name": "Pune to Mumbai Airport Cab",
        "description": "Choose Vedant Travels for your Pune to Mumbai Airport transfer. We provide timely and comfortable rides, ensuring you reach the airport without stress."
    },
    {
        "name": "Pune to Mumbai Ertiga Cab",
        "description": "For a spacious and comfortable ride from Pune to Mumbai, book an Ertiga with Vedant Travels. It’s perfect for families or small groups who need comfort during their journey."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Travel in style and comfort with an Innova from Pune to Mumbai. Ideal for a more luxurious ride, the Innova ensures a smooth journey for your business or leisure trip."
    },
    {
        "name": "Cab Service in Koregaon Park",
        "description": "Looking for reliable and professional cab service in Koregaon Park? Vedant Travels offers timely and comfortable rides for all your needs, whether local or long-distance."
    },
    {
        "name": "Taxi Cab Service in Koregaon Park",
        "description": "Our taxi service in Koregaon Park is available 24/7, ensuring that you always have a comfortable ride when you need it most. Whether it’s for a quick local ride or a longer trip, we've got you covered."
    },
    {
        "name": "Koregaon Park to Navi Mumbai Cab",
        "description": "Need a ride from Koregaon Park to Navi Mumbai? Vedant Travels offers affordable and reliable taxi services to Navi Mumbai, ensuring comfort throughout your journey."
    },
    {
        "name": "Koregaon Park to Airport Cab Service",
        "description": "Get to Mumbai Airport with ease and comfort by booking your cab with Vedant Travels. Our airport transfer services ensure you reach your destination on time."
    },
    {
        "name": "Koregaon Park to Thane Cab Service",
        "description": "If you're traveling from Koregaon Park to Thane, Vedant Travels offers reliable and affordable cab services for a seamless experience. Enjoy your journey with our comfortable vehicles and professional drivers."
    },
    {
        "name": "Koregaon Park to Mumbai Airport Innova",
        "description": "Book an Innova for your ride from Koregaon Park to Mumbai Airport. Spacious, comfortable, and luxurious, the Innova is perfect for a stress-free airport transfer."
    },
    {
        "name": "Innova Crysta on Rent in Koregaon Park",
        "description": "If you're looking for a premium ride, rent an Innova Crysta for your trip from Koregaon Park to Mumbai. Vedant Travels offers the Innova Crysta for a comfortable, luxurious journey."
    },
    {
        "name": "7-Seater Car on Rent in Koregaon Park",
        "description": "Need a larger vehicle for your trip? Rent a 7-seater car from Vedant Travels in Koregaon Park, ideal for family trips, group outings, or corporate travel."
    },
    {
        "name": "Ertiga on Rent in Koregaon Park",
        "description": "Rent an Ertiga from Koregaon Park for your trip. Spacious and comfortable, the Ertiga is perfect for small groups or families looking for an affordable yet comfortable ride."
    },
    {
        "name": "Luxury Car on Rent in Koregaon Park",
        "description": "Experience luxury on the road by renting a premium car from Vedant Travels in Koregaon Park. Whether it's for business or leisure, we offer a range of luxury cars for your journey."
    },
    {
        "name": "Contact Information",
        "description": "For bookings and inquiries, contact Vedant Travels at +91 8767459909. We provide professional and comfortable taxi services for all your travel needs between Koregaon Park, Pune, and Mumbai."
    }
]
,


"tableData": [
    ["koregaon park to mumbai airport cab", "koregaon park to mumbai international airport cab"],
    ["koregaon park to mumbai airport drop taxi", "koregaon park to mumbai airport one way taxi"],
    ["koregaon park to mumbai round trip", "cab service in koregaon Park"],
    ["koregaon park to santacruz cab fare", "koregaon park to mumbai central cab"],
    ["pune to mumbai airport cab", "pune to mumbai ertiga cab"],
    ["Pune to Mumbai Innova Cab", "Cab Service in Koregaon Park"],
    ["taxi cab service in koregaon park", "koregaon park to navi mumbai cab"],
    ["koregaon park to airport cab service", "koregaon park to thane cab service"],
    ["koregaon park to mumbai airport innova", "innova crysta on rent in koregaon park"],
    ["7 seater car on rent in koregaon park", "ertiga on rent in koregaon park"]
],
"whychoose": [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Vedant Travels, we value your time. Whether you’re heading to Mumbai for business or leisure, our drivers ensure timely pickups and drop-offs, making sure your journey from Koregaon Park to Mumbai is smooth and punctual."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a fleet of well-maintained, spacious vehicles equipped with air conditioning and comfortable seating, ensuring that you enjoy a relaxing and stress-free ride throughout your journey from Koregaon Park to Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced and well-trained in handling long-distance routes. They know the best routes to avoid traffic and ensure a smooth, safe, and comfortable journey. You can rely on them for an efficient trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Vedant Travels offers competitive pricing with no hidden charges. Our pricing is clear and transparent, so you can be sure that you’re getting the best value for your money without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring you have a secure and comfortable journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you need to travel early in the morning or late at night, Vedant Travels is available 24/7. You can book a cab anytime, and our customer service team is always ready to assist you with your needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a cab for your journey from Koregaon Park to Mumbai is easy and convenient. You can book your cab through our website or mobile app, or get assistance from our customer service team."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer customized travel packages to meet your specific needs. Whether you’re traveling for business, leisure, or a special occasion, we can tailor your journey to make it more comfortable and enjoyable."
    }
]



    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Koregaon Park to Mumbai cab with Vedant Travels?',
            answer: 'You can easily book a cab online via our website or mobile app. Alternatively, you can contact our customer service team for help with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel, including the route from Koregaon Park to Mumbai. They ensure a smooth, safe, and efficient journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Koregaon Park to Mumbai travel?',
            answer: 'We offer a variety of vehicles including sedans, SUVs, and luxury cars. All our vehicles are spacious, comfortable, and well-maintained to ensure you have a pleasant ride.',
        },
        {
            id: 4,
            question: 'How do I pay for my Koregaon Park to Mumbai cab rental?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments through our app, making the payment process simple and convenient for you.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Koregaon Park to Mumbai?',
            answer: 'Yes, you can book a round-trip cab. Just provide your return details when making the booking, and we will take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process, ensuring full transparency.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai after my drop-off?',
            answer: 'Yes, we offer sightseeing services in Mumbai. Explore famous spots like the Gateway of India, Marine Drive, and more with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Koregaon Park to Mumbai cab?',
            answer: 'Our vehicles can accommodate standard luggage. If you have extra luggage or special requirements, please let us know when booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Koregaon Park and Mumbai?',
            answer: 'Yes, we provide corporate travel services, including airport transfers, business meetings, and events. Get in touch with us for tailored corporate travel packages.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Koregaon Park to Mumbai journey?',
            answer: 'Vedant Travels is known for offering reliable, affordable, and comfortable travel with professional drivers, well-maintained vehicles, and a focus on customer satisfaction. We ensure a smooth and stress-free journey from Koregaon Park to Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sameer Patil",
            title: "Customer",
            quote: "I had a wonderful experience traveling from Koregaon Park to Mumbai with Vedant Travels. The driver was professional and courteous, and the vehicle was clean and comfortable. I reached Mumbai on time, and the entire journey was hassle-free!",
            rating: 5,
        },
        {
            name: "Mrs. Snehal Deshpande",
            title: "Customer",
            quote: "We chose Vedant Travels for our family trip from Koregaon Park to Mumbai, and it was a fantastic experience. The booking process was smooth, the vehicle was spacious, and the driver was friendly. Highly recommend it!",
            rating: 5,
        },
    ];
    











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const url = "https://www.vedanttravels.in/koregaon-park-to-mumbai-cab";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/koregaon-park-to-mumbai-cab-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Koregaon Park to Mumbai Cab | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/koregaon-park-to-mumbai-cab.jpg",
    "description": "Book cabs from Koregaon Park (KP) to Mumbai. Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, trained drivers, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 25417,          // within 8k–180k
      "reviewCount": 17102
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "1499",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Koregaon Park to Mumbai Cab",
        "description": "Koregaon Park → Mumbai cab booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, on-time pickup, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Koregaon Park to Mumbai Cab", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Koregaon Park", "KP", "Kalyani Nagar", "Viman Nagar", "Pune", "Mumbai", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 141902      // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Koregaon Park to Mumbai Cab",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way and round-trip taxi from Koregaon Park to Mumbai — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "koregaon-park-mumbai-cab",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "1499",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 25417,     // within 8k–180k
            "reviewCount": 17102
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "KP Resident" },
            "datePublished": "2025-07-18",
            "reviewBody": "Pickup from North Main Road (Lane 5) to T2 was on time. Clean Innova and smooth Expressway ride.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Lane 7 Traveler" },
            "datePublished": "2025-05-10",
            "reviewBody": "Early morning drop to Andheri. Fixed fare and courteous driver. Recommended.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Which KP pickup points do you cover?",
            "acceptedAnswer": { "@type": "Answer", "text": "North Main Road Lanes 5–7, South Main Road, German Bakery area, Osho, Jewel Square, Bund Garden Road; nearby Kalyani Nagar & Viman Nagar on request." }
          },
          {
            "@type": "Question",
            "name": "What is the starting fare from KP to Mumbai?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹1499. Final fare depends on car type, pickup time, traffic, and exact drop location." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway tolls and airport charges included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include Expressway tolls. Airport entry/parking may be additional—shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars can I book?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—clean vehicles with verified drivers, AC, and GPS tracking." }
          }
        ]
      }
    ]
  };





    return (
        <div>
           

       <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Koregaon Park to Mumbai Cab | Fixed Fare Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book cabs from Koregaon Park (KP) to Mumbai at ₹1499 onwards. Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Koregaon Park to Mumbai Cab, KP to Mumbai Taxi, Lane 5 to Mumbai Cab, Lane 7 to Mumbai Taxi, Bund Garden to Mumbai Cab, Kalyani Nagar to Mumbai Taxi, Innova KP to Mumbai"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Koregaon Park to Mumbai Cab | Fixed Fare Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable KP → Mumbai cabs—transparent fares & professional drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Koregaon Park to Mumbai Cab | Fixed Fare Taxi | Vedant Travels" />
        <meta name="twitter:description" content="KP → Mumbai cabs at ₹1499 onwards. Book now for on-time pickup." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>


            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Koregaonparktomumbaicab;